import { useQuery, UseQueryFunctionResult } from "@lookiero/messaging-react";
import { CheckoutFeedbackQuestionProjection } from "../../../../projection/checkoutFeedback/checkoutFeedback";
import { viewCheckoutFeedbackDefinitionByCheckoutId } from "../../../../projection/checkoutFeedback/viewCheckoutFeedbackDefinitionByCheckoutId";
import { MESSAGING_CONTEXT_ID } from "../../../delivery/baseBootstrap";

interface UseViewCheckoutFeedbackDefinitionByCheckoutIdFunctionArgs {
  readonly checkoutId: string;
}

interface UseViewCheckoutFeedbackDefinitionByCheckoutIdFunction {
  (
    args: UseViewCheckoutFeedbackDefinitionByCheckoutIdFunctionArgs,
  ): UseQueryFunctionResult<CheckoutFeedbackQuestionProjection[]>;
}

const useViewCheckoutFeedbackDefinitionByCheckoutId: UseViewCheckoutFeedbackDefinitionByCheckoutIdFunction = ({
  checkoutId,
}) =>
  useQuery({
    query: viewCheckoutFeedbackDefinitionByCheckoutId({ checkoutId }),
    contextId: MESSAGING_CONTEXT_ID,
    options: { staleTime: Infinity, retry: false, refetchOnWindowFocus: false },
  });

export { useViewCheckoutFeedbackDefinitionByCheckoutId };
